module.exports = __webpack_public_path__ + "static/media/medical.5129e6b4.svg";